import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Menu,
  MenuItem,
  IconButton,
  Typography,
  Paper,
  useMediaQuery,
  FormControl,
  InputLabel,
  Select,
  MenuItem as MuiMenuItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { DataGrid } from "@mui/x-data-grid";
import { useStyles } from "../../assets/styles/Theme";

function ViewDataGrid({
  columns = [],
  rows = [],
  menuItems = [],
  tabletitle = "",
  gridid = "",
  displayActions = true,
  displaycheckbox = false,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [density, setDensity] = useState("standard");
  const theme = useTheme();
  const styles = useStyles(theme);
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleOpenUserMenu = (event, row) => {
    setAnchorEl({ anchor: event.currentTarget, row });
  };

  const handleCloseUserMenu = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (menuItem, row) => {
    menuItem.onClick(row[gridid]);
    handleCloseUserMenu();
  };

  if (!columns || !rows || !Array.isArray(columns) || !Array.isArray(rows)) {
    console.error("Invalid columns or rows");
    return null;
  }

  // Convert table titles to title case
  const titleCase = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // Add action column if displayActions is true
  const actionColumn = displayActions
    ? [
        {
          field: "actions",
          headerName: "Actions",
          width: 100,
          headerAlign: "center",
          align: "center",
          // position: "fixed",
          renderCell: (params) => (
            <IconButton
              onClick={(event) => handleOpenUserMenu(event, params.row)}
            >
              <MoreVertIcon />
            </IconButton>
          ),
          sortable: false,
          filterable: false,
          disableColumnMenu: true,
          pinned: "right",
          cellClassName: "actions-column-cell",
          headerClassName: "actions-column-header",
        },
      ]
    : [];

  const dataGridColumns = columns.map((column) => ({
    ...column,
    headerName: titleCase(column.headerName),
    headerAlign: column.textAlign ? column.textAlign.toLowerCase() : "left",
    align: column.textAlign ? column.textAlign.toLowerCase() : "left",
    renderCell:
      column.field === "colorcode"
        ? (params) => (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundColor: params.value,
                borderRadius: 1,
              }}
            />
          )
        : undefined,
  }));

  return (
    <>
      <Paper sx={styles.VDG_paper}>
        {/* <Box sx={styles.VDG_box}> */}

        {/* Row Density Dropdown */}

        {}
        <Box sx={{ height: 480, width: "100%" }}>
          <DataGrid
            columns={[...dataGridColumns, ...actionColumn]}
            rows={rows}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 100]}
             checkboxSelection ={displaycheckbox}
            disableSelectionOnClick
            density={density}
            components={{
              ColumnMenu: null,
            }}
            sx={{
              fontSize: theme.typography.body_s,
              p: 1,
              overflowX: "auto",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: theme.palette.background.paper,
                textTransform: "capitalize",
              },
              // "& .MuiDataGrid-cell": {
              //   display: "flex",
              //   alignItems: "center",
              //   justifyContent: "center",
              // },
              "& .MuiDataGrid-columnHeaderTitle": {
                textAlign: "center",
                width: "100%",
                textTransform: "capitalize",
                fontSize: theme.typography.subtitle_m,
                fontWeight: 600,
              },
              "& .MuiDataGrid-columnHeader--pinnedRight": {
                backgroundColor: theme.palette.background.paper,
              },
              "& .MuiDataGrid-cell--pinnedRight": {
                backgroundColor: theme.palette.background.paper,
              },

              "& .MuiDataGrid-container--top  [role=row]": {
                backgroundColor: theme.palette.background.bgShade_1,
                color: theme.palette.text.secondary,

                // boxShadow: 1,
              },
              "& .actions-column-cell": {
                position: "sticky",
                right: 0,
                backgroundColor: theme.palette.background.paper,
                zIndex: 1,
                // borderLeft: `1px solid ${theme.palette.divider}`,
              },
              "& .actions-column-header": {
                position: "sticky",
                right: 0,
                backgroundColor: theme.palette.background.bgShade_1,
                zIndex: 2,
                // borderLeft: `1px solid ${theme.palette.divider}`,
              },
            }}
          />
        </Box>
        {/* </Box> */}
        <Menu
          anchorEl={anchorEl?.anchor}
          open={Boolean(anchorEl)}
          onClose={handleCloseUserMenu}
          sx={{ ...styles.VDG_colActionIconMenu }}
        >
          {menuItems.map((menuItem, index) => (
            <MenuItem
              key={index}
              onClick={() => handleMenuItemClick(menuItem, anchorEl?.row)}
              sx={{ ...styles.VDG_colActionIcon }}
            >
              {menuItem.icon}
              <span className="menuItemText">{menuItem.text}</span>
            </MenuItem>
          ))}
        </Menu>
      </Paper>
    </>
  );
}

ViewDataGrid.propTypes = {
  columns: PropTypes.array,
  rows: PropTypes.array,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.node,
    })
  ),
  tabletitle: PropTypes.string,
  gridid: PropTypes.string,
  displayActions: PropTypes.bool,
  displaycheckbox: PropTypes.bool,
};

export default ViewDataGrid;
